module.exports = __webpack_public_path__ + "img/banner_news.f8f5b7b1.png";